import { PriceTypeModal } from 'components/PriceTypeModal';

import { useActions } from './Actions.hooks';
import * as S from './Actions.styles';

type ActionsType = {
  noPadding?: boolean;
};

const defaultProps: Partial<ActionsType> = {
  noPadding: false,
};

export function Actions(props: ActionsType): React.ReactElement {
  const { noPadding } = { ...defaultProps, ...props };
  const {
    buttonsDataIntoComponent,
    deleteModal,
    sendModal,
    duplicateModal,
    priceTypeModalAction,
    availablePriceTypes,
    handlePriceTypeConfirm,
    closePriceTypeModal,
  } = useActions();

  return (
    <S.Container noPadding={noPadding}>
      {buttonsDataIntoComponent}

      {deleteModal}
      {sendModal}
      {duplicateModal}

      {priceTypeModalAction && (
        <PriceTypeModal
          onClose={closePriceTypeModal}
          onConfirm={handlePriceTypeConfirm}
          availableTypes={availablePriceTypes}
        />
      )}
    </S.Container>
  );
}
